<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/fzFnCD/tc-custom/9781453286876.jpg?1704717895410" alt="This image is the cover for the book Burning Rose"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Burning Rose
      </h1>
      <p class="bookDescription body article font2">
        <b>An environmental journalist stumbles into the deadly world of mega-corporations </b><i><br/>Burning Rose</i> is a gripping mystery from Shirley Kennett, author of the beloved PJ Gray series. The story follows Casey Washington, a freelance journalist with environmental convictions. When she lands a rare interview with Robert Gunner, CEO of World Power, a company building a controversial dam in the Amazon rainforest, she anticipates a personal triumph—only to have the story go terribly awry.  Heads of other big corporations start dying in gruesome fashion, at the hands of a mysterious group known as “The Six.” Washington’s investigative instinct kicks in but her search is not made any easier by her improbable attraction to the reclusive CEO Gunner. <i>Burning Rose</i> is an eco-thriller full of puzzles and high-gear action with global consequences.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Shirley  Kennett
      </h2>
      
      <p class="authorDescription body article">Shirley Kennett is the author of the PJ Gray series of thrillers, which center on a psychologist and single mother who deploys virtual reality technology to solve homicides for the St. Louis Police Department. The novels in the series include <i>Gray Matter</i>, <i>Fire Cracker</i>, <i>Chameleon</i>, <i>Act of Betrayal</i>, and <i>Time of Death</i>. She is also the author of <i>Burning Rose</i>, a stand-alone environmental mystery. Under the pseudonym Dakota Banks, Kennett wrote the Mortal Path series of supernatural thrillers. She lives in Missouri. &#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?19df0b80